import { tApi } from 'tplus-api';
import { PosInitData } from 'tplus-poslogin';

export default class PrintApi {
    /**
     * 获取打印模板及格式
     * @param {*} stparam 
     */
    static async GetBillOneTaskAll(stparam) {
        return await tApi({ "stparam": stparam }, 'chanjet.EAP.Print.Interface.ICloudPrintService.GetBillOneTaskAll', false, false);
    }
    /**
     * 根据模板名称获取模板
     * @param {*} name 
     */
    static async GetPOSParamSolutionDetailByName(name) {
        let idStore = PosInitData('storeID');
        return await tApi({ "idStore": idStore, "name": name }, 'chanjet.RE.IParamSolution.GetPOSParamSolutionDetailByName', false, false);
    }

    /**
     * 获取门店方案
     */
    static async getStoreParams() {
        const resp = await tApi({}, 'chanjet.RE.paramSolution.GetStoreParams', false, false);
        return resp;
    }
    //获取当前门店硬件配置信息
    static async getHardwareSetting() {
        const data = await tApi({}, 'chanjet.RE.paramSolution.GetHardwareSetting', false, false);
        return data;
    }
    //获取当前门店硬件配置信息
    static async GetPrintInfomation(dto) {
        let param={};
        param.Idstore=dto.Idstore;
        param.POSCode=dto.POSCode;
        
        const data = await tApi({ param: JSON.stringify(param) }, 'chanjet.RE.NewPos.GetPrintInfomation', false, false);
        return data;
    }

    static async PrintByYinMei(params){
        const data = await tApi(params, 'Ufida.T.EAP.Print.Interface.ICloudPrintService.PrintJob', false, false);
        return data;
    }


}